import AppSpinner from "../../elements/AppSpinner";

export default function LoadingView() {
  return (
    <div className="d-flex justify-content-center align-items-center h-100vh">
      <AppSpinner
        color="primary"
        style={{ fontSize: 30, height: 50, width: 50 }}
      />
    </div>
  );
}
